module.exports = __webpack_public_path__ + "static/media/1992_maleRate_femaleRate.f7b61117.png";